module.exports = __webpack_public_path__ + "static/media/bg.53c27dd8.png";